import { render, staticRenderFns } from "./proofread.vue?vue&type=template&id=8153ff2c&scoped=true"
import script from "./proofread.vue?vue&type=script&lang=js"
export * from "./proofread.vue?vue&type=script&lang=js"
import style0 from "./proofread.vue?vue&type=style&index=0&id=8153ff2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8153ff2c",
  null
  
)

export default component.exports